/** @type {String} */
export let ctaCaption;
/** @type {String} */
export let ctaLabel;
export let ctaHref = '';
/** @type {String} */
export let description;
/** @type {any} */
export let media;


import LogosList from './LogosList.svelte';

export default {
  component: LogosList,
  name: 'Logos List',
  inputs: [
    {
      name: 'logos',
      type: 'list',
      subFields: [
        {
          name: 'href',
          type: 'url'
        },
        {
          name: 'imageSrc',
          type: 'file'
        },
        {
          name: 'name',
          type: 'string'
        }
      ]
    },
  ]
}
